import { FC } from 'react';

import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import PaymentsOutlinedIcon from '@mui/icons-material/PaymentsOutlined';

import { Props } from './types';

const AverageSalePrice: FC<Props> = ({ value, maxSoldDaysAgo, lotsCount }) => {
  if (value === null) {
    return null;
  }

  return (
    <Box className="price-summary" bgcolor="#f5f5f5" borderRadius={2} padding={2}>
      <Stack direction="row" alignItems="center" gap={2}>
        <Box padding={1} borderRadius={2} bgcolor="#fff">
          <PaymentsOutlinedIcon sx={{ color: '#000' }} fontSize="large" />
        </Box>

        <Stack direction="column" justifyContent="center">
          <Typography variant="h4" color="primary">
            {'\u20AC'}
            {value.toFixed(2)}
          </Typography>
          <Typography variant="body2">
            {'\u0421\u0440\u0435\u0434\u043d\u044f\u044f \u0446\u0435\u043d\u0430 \u0437\u0430 \u043f\u043e\u0441\u043b\u0435\u0434\u043d\u0438\u0435 '}
            <strong>{maxSoldDaysAgo}</strong>{' '}
            {'\u0434\u043d\u0435\u0439 \u043d\u0430 \u043e\u0441\u043d\u043e\u0432\u0435 '}
            <strong>{lotsCount}</strong>{' '}
            {'\u043b\u043e\u0442\u043e\u0432'}
          </Typography>
        </Stack>
      </Stack>
    </Box>
  );
};

export { AverageSalePrice };
